import { Factory, trait } from 'miragejs';

export default Factory.extend({
  branding: 'logo',
  photo: true,
  timeOfEntryEnabled: false,
  customMessage: 'siong is awesome',
  css: 'body {}',
  defaultCss: 'body {}',
  defaultHtml: '<div></div>',
  sampleLogoPath: '/sample_badge_logo.png',
  samplePhotoPath: '/sample_badge_photo.png',
  enabled: true,
  extraFieldOne: 'field Your Company',
  extraFieldOneLabel: true,
  extraFieldTwo: 'field Your Car',
  extraFieldTwoLabel: true,
  extraFieldThree: 'field Your Favorite Color',
  extraFieldThreeLabel: true,
  footer: 'none',
  header: 'none',
  notes: 'siong is awesome',
  showLabels: true,
  showPhoto: true,
  autoPrintEnabled: false,
  uiHookOne: null,
  uiHookTwo: null,

  withFlowAssign: trait({
    afterCreate(badge, server) {
      const flow = server.schema.flows.findBy({ badgeId: null });

      flow?.update({
        badge: badge,
      });
    },
  }),

  withQrCode: trait({
    afterCreate(badge, server) {
      const locationId = badge?.flow?.location?.id;

      if (!locationId) {
        throw new Error('The trait `withQrCode` requires the badge to be associated to a flow with a location');
      }

      const uiHook = server.create('ui-hook', 'asBadgeQrCode', { locationId });
      const urn = `HOOKS|TRIGGER_NAME:${uiHook.triggerName}::UI_HOOK_ID:${uiHook.uiHookId}`;

      badge.update({ uiHookTwo: urn });
    },
  }),

  withBarcode: trait({
    afterCreate(badge, server) {
      const locationId = badge?.flow?.location?.id;

      if (!locationId) {
        throw new Error('The trait `withBarcode` requires the badge to be associated to a flow with a location');
      }

      const uiHook = server.create('ui-hook', 'asBadgeBarcode', { locationId });
      const urn = `HOOKS|TRIGGER_NAME:${uiHook.triggerName}::UI_HOOK_ID:${uiHook.uiHookId}`;

      badge.update({ uiHookOne: urn });
    },
  }),
});
